const get = (key: string): string => {
    const env = import.meta.env['VITE_FB_' + key];
    if (env) return env;
    throw new Error(`Env var VITE_FB_${key} was not provided`);
};

export const firebaseConfig = {
    apiKey: get('API_KEY'),
    authDomain: get('AUTH_DOMAIN'),
    projectId: get('PROJECT_ID'),
    storageBucket: get('STORAGE_BUCKET'),
    messagingSenderId: get('MESSAGING_SENDER_ID'),
    appId: get('APP_ID'),
    measurementId: get('MEASUREMENT_ID'),
    publicVapid: get('PUBLIC_VAPID'),
};
